import {
  Box,
  Card,
  CardContent,
  Container,
  Grid2,
  Stack,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { PageTitle } from "../../commanComponents/PageTitle";
import { LinearProgressBar } from "../../commanComponents/LinearProgressBar";
import { String } from "../../constants/Strings";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import CommanButton from "../../commanComponents/CommanButton";
import { getColor } from "../../style/color/color";
import ACRButton from "../../commanComponents/ACRButton";
import { commanButtomStyled } from "../../style/styleComponents/StyledChildEducationMarriage";
import AmountSlider from "./AmountSlider";
import { useNavigate } from "react-router-dom";
import { DataContext } from "../../Hooks/context/ChildData";
import CustomSnackbar from "../../commanComponents/CustomerSnackbar";
import { useLocalStorage } from "../../logic/LocalStorage/LocalStorage";
import { AuthContext } from "../../Hooks/context/AuthContext";
import bulb from "../../assets/icon/bulbsvgrepo.png";
import AgeSlider from "./AgeSlider";
import { useSavingGoals } from "../../api/apiEndpoints/SavingGoals";
import { CoursesArray } from "../../constants/CoursesArray";
import { initialCourseValues } from "../../constants/CoursesInitialValues";
import { fonts } from "../../style/fonts/fonts";
import { gaCustomEvent } from "../../logic/CommonFunctions";
import { OTPVerifyContext } from "../../Hooks/context/OTPVeriryContext";

const ChildCard = ({
  childName,
  childAge,
  isCollapsed,
  handleClick,
  bgColor,
  handleCollapse,
  rangeOfCourse,
  weddingBudget,
  educationYear,
  weddingYear,
  activeButton,
  handleRangeOfCourseChange,
  handleWeddingBudgetChange,
  setEducationYear,
  setWeddingYear,
  isReadOnlyRangeofCourse,
  course,
}) => (
  <Card
    sx={{
      mt: "20px",
      mr: "30px",
      ml: "30px",
      mb: "50px",
      borderRadius: 4,
      boxShadow: 2,
      p: "7px",
    }}
  >
    <CardContent
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: getColor.NeutralLightN60,
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
      }}
    >
      <Typography
        variant="h5"
        component="div"
        sx={{
          color: getColor.NeutralDark600,
          fontSize: "1rem",
          fontFamily: fonts.manrope,
          fontWeight: "700",
        }}
      >
        {`${childName}: ${childAge} yrs`}
      </Typography>
      {!isCollapsed ? (
        <KeyboardArrowDown
          onClick={handleCollapse}
          sx={{
            fontSize: "20px",
            cursor: "pointer",
          }}
        />
      ) : (
        <KeyboardArrowUp
          onClick={handleCollapse}
          sx={{
            fontSize: "20px",
            cursor: "pointer",
          }}
        />
      )}
    </CardContent>
    {!isCollapsed && (
      <CardContent>
        <Typography
          variant="h6"
          sx={{
            color: getColor.NeutralDark700,
            fontSize: 16,
            fontFamily: fonts.manrope,
            fontWeight: "700",
          }}
        >
          {`Select a dream course for ${childName} ?`}
        </Typography>
        <Grid2 container spacing={2} sx={{ mt: 2 }}>
          {CoursesArray.map((course) => (
            <Grid2 item xs={4} key={course}>
              <CommanButton
                label={course}
                variant={activeButton === course ? "contained" : "outlined"}
                style={commanButtomStyled(activeButton, course, bgColor)}
                onClickButton={() => handleClick(course)}
                fullWidth
              >
                {course}
              </CommanButton>
            </Grid2>
          ))}
        </Grid2>
        <Box
          sx={{
            width: "100%",
            mt: "10px",
            p: "2px",
            backgroundColor: getColor.ExtendedPalateCyberYellowCy100,
          }}
        >
          <Typography
            sx={{
              color: getColor.NeutralDark700,
              fontSize: 12,
              fontFamily: fonts.manrope,
              fontWeight: 600,
            }}
          >
            <img
              src={bulb}
              alt="Bulb Icon"
              style={{
                width: 20,
                height: 20,
              }}
            />
            {`Avg cost of ${course || "Engineering"} in India is 
              ${isReadOnlyRangeofCourse || 15} lakhs
           `}
          </Typography>
        </Box>

        <AmountSlider
          question={`Approximate cost of your ${childName}'s education?`}
          income={rangeOfCourse || 0}
          setIncome={handleRangeOfCourseChange}
        />
        <AgeSlider
          question={`By when do you need the education funds for ${childName} ? (years)`}
          totalAge={educationYear || ""}
          onAgeChange={setEducationYear}
        />
        <AmountSlider
          question={`What is your estimated budget for ${childName}'s wedding?`}
          income={weddingBudget || 0}
          setIncome={handleWeddingBudgetChange}
        />
        <Box
          sx={{
            width: "100%",
            mt: "10px",
            p: "2px",
            backgroundColor: getColor.ExtendedPalateCyberYellowCy100,
          }}
        >
          <Typography
            sx={{
              color: getColor.NeutralDark700,
              fontSize: 12,
              fontFamily: fonts.manrope,
              fontWeight: 600,
            }}
          >
            <img
              src={bulb}
              alt="Bulb Icon"
              style={{
                width: 20,
                height: 20,
              }}
            />
            {String.ChildMarriageandEducation.Screen2.hintTextMarriage}
          </Typography>
        </Box>
        <AgeSlider
          question={`By when do you need the wedding funds for ${childName} ? (years)`}
          totalAge={weddingYear || ""}
          onAgeChange={setWeddingYear}
        />
      </CardContent>
    )}
  </Card>
);

const ChildEducationMarriage = () => {
  const [isCollapsed, setIsCollapsed] = useState([]);
  const [bgColor, setBgColor] = useState(
    getColor.ExtendedPalettesSummerSkySS100
  );
  const [, setActiveButton] = useState(null);
  const [childData, setChildData] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarmessage, setSnackbarMessage] = useState({
    message: "",
    severity: "",
  });
  // const [isReadOnlyRangeofCourse, setIsReadOnlyRangeofCourse] = useState(0);
  const navigate = useNavigate();
  const { collectedData, collectData } = useContext(DataContext);
  const { saveLocalFinancialData, retrieveLocalFinancialData } =
    useLocalStorage();
  const { saveGoals } = useSavingGoals();
  const { authTokens } = useContext(AuthContext);
  const { userId } = authTokens;
  const childrens = collectedData.children;
  const selectedGoals = collectedData.selectedGoals || [];

  // Lead Id as verifyData.CustomerId from OTPVerifyContext
  const { verifyData } = useContext(OTPVerifyContext);

  const handleCollapse = (index) => {
    setIsCollapsed((prevState) => {
      const newState = [...prevState];
      newState[index] = !newState[index];
      return newState;
    });
  };
  useEffect(() => {
    const retrieveSavedData = async () => {
      try {
        const data = await retrieveLocalFinancialData(
          `childfuturedetails-${userId}`
        );

        if (data && Array.isArray(data)) {
          if (data.length < collectedData.count) {
            data.push({
              dreamCourse: "",
              rangeOfCourse: 0,
              weddingBudget: 0,
              educationYear: 0,
              weddingYear: 0,
            });

            setChildData(data);
          } else {
            setChildData(data);
          }
        }
      } catch (e) { }
    };
    retrieveSavedData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const childrens = collectedData.children;

    const childDataArray = childrens.map(() => ({
      dreamCourse: "",
      rangeOfCourse: 0,
      weddingBudget: 0,
      educationYear: 0,
      weddingYear: 0,
    }));

    setChildData(childDataArray);
  }, [collectedData]);

  const handleRangeOfCourseChange = (index, range) => {
    const updatedData = [...childData];
    updatedData[index].rangeOfCourse = range;
    setChildData(updatedData);
  };
  const handleDreamCourseChange = (index, course) => {
    setActiveButton(course);
    setBgColor(getColor.SecondaryMidnightBlue);

    const updatedData = [...childData];

    const courseValue = initialCourseValues[course];
    // if (courseValue) {
    //   setIsReadOnlyRangeofCourse(courseValue);
    // }
    updatedData[index] = {
      ...updatedData[index],
      dreamCourse: course,
      rangeOfCourse: 0,
      range: courseValue ? courseValue : 0,
    };

    setChildData(updatedData);
  };
  const handleWeddingBudgetChange = (index, budget) => {
    const updatedData = [...childData];
    updatedData[index].weddingBudget = budget;
    setChildData(updatedData);
  };
  const handleWeddingYear = (index, year) => {
    const updateData = [...childData];
    updateData[index].weddingYear = year;
    setChildData(updateData);
  };
  const handleEducationYear = (index, year) => {
    const updateData = [...childData];
    updateData[index].educationYear = year;
    setChildData(updateData);
  };
  const validateChildData = (childData) => {
    let isValid = true;

    childData.forEach((child) => {
      if (!child.dreamCourse || child.rangeOfCourse === 0) {
        isValid = false;
      }
    });

    return isValid;
  };

  const handleContinue = async () => {
    gaCustomEvent(String.gaEventName.acrPortfolio, String.gaEventClickName.acrPortfolioChildrenEducationAndMarriageContinue, verifyData.customerId);

    const updatedChildren = childrens.map((child, index) => ({
      ...child,
      dreamCourse: childData[index].dreamCourse,
      dreamCourseAmount: 0, // need to remove
      educationCostEstimate: childData[index].rangeOfCourse,
      weddingCostEstimate: childData[index].weddingBudget,
      educationTargetYear: childData[index].educationYear,
      weddingTargetYear: childData[index].weddingYear,
    }));

    const isValid = validateChildData(childData);
    if (!isValid) {
      setSnackbarOpen(true);
      setSnackbarMessage({
        message: String.ChildPlannig.pleaseAllFeilds,
        severity: String.ErrorSeverity,
      });
      return;
    } else {
      saveLocalFinancialData(`childfuturedetails-${userId}`, childData);
      try {
        const goalData = {
          userId: userId,
          isParent: collectedData.isParent,
          futureGoalName: "",
          requiredAmount: "",
          targetYear: "",
          idealRetirement: "",
          children: updatedChildren ? updatedChildren : [],
          dependants: collectedData.dependants ? collectedData.dependants : [],
          goals: [...(collectedData.selectedGoals || [])],
        };
        if (!userId && !goalData.isParent) {
          setSnackbarOpen(true);
          setSnackbarMessage({
            message: String.errorMessageforGoalsave,
            severity: String.ErrorSeverity,
          });
          return;
        }

        collectData({ ...goalData });

        const shouldCallSaveApi =
          selectedGoals.length === 1 ||
          (selectedGoals.includes(2) && selectedGoals.length === 1) ||
          (selectedGoals.includes(1) &&
            selectedGoals.includes(2) &&
            !selectedGoals.includes(5) &&
            !selectedGoals.includes(4));

        if (shouldCallSaveApi) {
          try {
            const response = await saveGoals(goalData);
            if (response.httpCode === 200) {
              setSnackbarOpen(true);
              setSnackbarMessage({
                message: String.successMessageforGoalsave,
                severity: String.successSeverity,
              });
              setTimeout(() => {
                navigate(String.navigations.fetchinfo);
              }, 1000);
            } else {
              setSnackbarOpen(true);
              setSnackbarMessage({
                message: String.errorMessageforGoalsave,
                severity: String.ErrorSeverity,
              });
            }
          } catch (error) {
            setSnackbarOpen(true);
            setSnackbarMessage({
              message: String.errorMessageforGoalsave,
              severity: String.ErrorSeverity,
            });
          }
        } else {
          if (collectedData.selectedGoals.includes(5)) {
            navigate(String.navigations.retirementgoal);
          } else {
            navigate(String.navigations.investmentgoal);
          }
        }
      } catch (error) {
        setSnackbarOpen(true);
        setSnackbarMessage({
          message: String.errorMessageforGoalsave,
          severity: String.ErrorSeverity,
        });
      }
    }
  };
  return (
    <Stack>
      <Box
        sx={{
          overflowY: "auto",
          flexGrow: 1,
          pb: "80px",
        }}
      >
        <Container sx={{ flexGrow: 1 }}>
          <PageTitle
            PageTitle={String.ChildMarriageandEducation.Screen1.Title}
          />
          <LinearProgressBar
            dragMessage={String.ChildMarriageandEducation.Screen1.dragMessage}
            progress={38}
            progressNumber={38}
            stepNumber={2}
          />
        </Container>
        {childrens.map((child, index) => (
          <ChildCard
            key={index}
            childName={child.name}
            childAge={child.age}
            isCollapsed={isCollapsed[index]}
            bgColor={bgColor}
            activeButton={childData[index]?.dreamCourse}
            handleClick={(course) => handleDreamCourseChange(index, course)}
            handleCollapse={() => handleCollapse(index)}
            rangeOfCourse={childData[index]?.rangeOfCourse || 0}
            handleRangeOfCourseChange={(range) =>
              handleRangeOfCourseChange(index, range)
            }
            weddingBudget={childData[index]?.weddingBudget || 0}
            handleWeddingBudgetChange={(budget) =>
              handleWeddingBudgetChange(index, budget)
            }
            educationYear={childData[index]?.educationYear || 0}
            weddingYear={childData[index]?.weddingYear || 0}
            setEducationYear={(year) => handleEducationYear(index, year)}
            setWeddingYear={(year) => handleWeddingYear(index, year)}
            isReadOnlyRangeofCourse={childData[index]?.range}
            course={childData[index]?.dreamCourse}
          />
        ))}
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mt: isCollapsed ? "20px" : "20%",
          p: "10px",
        }}
      >
        <ACRButton
          label={String.continue}
          style={{
            width: "100%",
            maxWidth: "350px",
            backgroundColor: getColor.ColorButtonPrimarysurface,
            color: getColor.PrimaryWhite,
            borderRadius: "40px",
            p: "10px",
            mb: "40px",
            height: "60px",
            lineHeight: "22.2px",
            fontWeight: 700,
            fontSize: "16px",
            textAlign: "center",
            textTransform: "initial",
          }}
          onClickButton={handleContinue}
        />
      </Box>
      <CustomSnackbar
        open={snackbarOpen}
        handleClose={() => setSnackbarOpen(false)}
        severity={snackbarmessage.severity}
        message={snackbarmessage.message}
      />
    </Stack>
  );
};

export default ChildEducationMarriage;
